// Uyarlanmış kopya — emsal: beltasapp/frontend/src/shared/ui/izgara/izgara-pano.ts
// Fark: Excel'in tırnaklı hücreleri (sekme/satır sonu/tırnak içeren) ayrıştırılır ve yazılır.

/**
 * Parses clipboard text (TSV as Excel writes it) into a row x column matrix.
 *
 * - Rows end with `\r\n` or `\n`; ONE trailing newline is dropped, blank lines in the middle stay.
 * - A field starting with `"` is quoted: it may hold tabs and newlines, `""` is a literal quote.
 *   A quote that does not close properly (no tab/newline/end right after it) is read literally.
 */
export function parseTsv(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let i = 0
  const n = text.length
  let rowOpen = false // a field was started on the current row

  const endRow = () => {
    rows.push(row)
    row = []
    rowOpen = false
  }

  while (i < n) {
    // Start of a field.
    rowOpen = true
    let field = ''
    let quotedOk = false
    if (text[i] === '"') {
      // Look for the closing quote.
      let j = i + 1
      let buf = ''
      let closed = false
      while (j < n) {
        if (text[j] === '"') {
          if (text[j + 1] === '"') {
            buf += '"'
            j += 2
            continue
          }
          closed = true
          break
        }
        buf += text[j]
        j++
      }
      const after = text[j + 1]
      if (closed && (after === undefined || after === '\t' || after === '\n' || after === '\r')) {
        field = buf
        i = j + 1
        quotedOk = true
      }
    }
    if (!quotedOk) {
      let j = i
      while (j < n && text[j] !== '\t' && text[j] !== '\n' && text[j] !== '\r') j++
      field = text.slice(i, j)
      i = j
    }
    row.push(field)

    // After the field: separator.
    if (i >= n) break
    if (text[i] === '\t') {
      i++
      // A tab at the very end opens one more (empty) field.
      if (i >= n) {
        row.push('')
        break
      }
    } else {
      if (text[i] === '\r' && text[i + 1] === '\n') i += 2
      else i += 1
      endRow()
      // A single trailing newline does not start another row.
      if (i >= n) break
    }
  }
  if (rowOpen) endRow()
  return rows
}

function quoteIfNeeded(cell: string): string {
  return /[\t\n\r"]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell
}

/** Serialises a matrix to TSV (tabs between cells, `\n` between rows; Excel-compatible quoting). */
export function serializeTsv(matrix: string[][]): string {
  return matrix.map((r) => r.map(quoteIfNeeded).join('\t')).join('\n')
}
